// middleware/auth.js

import { defineNuxtRouteMiddleware, navigateTo } from "#imports";
import { useAuthStore } from "~/stores/authStore";
import publicPaths from "~/data/sitemapRoutes.json";
const publicPatterns = [
  /^\/$/, // Accueil
  /^\/courses$/,
  /^\/course\/[^/]+$/, // Tous les cours (liste + détail)
  /^\/articles$/,
  /^\/article\/[^/]+$/,
  /^\/cart$/,
  /^\/cart\/?$/,
  /^\/books$/,
  /^\/book\/[^/]+$/,
  /^\/contribute$/,
  /^\/404$/,
  /^\/403$/,
  /^\/verify-email$/,
/^\/verify\/certificate(\/)?$/,

  /^\/crafts$/,
  /^\/craft\/[^/]+$/,
  /^\/stationeries$/,
  /^\/forbidden$/,
  /^\/stationery\/[^/]+$/,
  /^\/clothings$/,
  /^\/clothing\/[^/]+$/,
  /^\/shop$/,
  /^\/shop\/?[^/]*$/, // Shop et variations (shop/checkout/...)
  /^\/contact$/,
  /^\/documentation(\/.*)?$/, // Toute la doc et ses sous-pages
  /^\/privacy$/,
  /^\/terms$/,
  /^\/login$/,
  /^\/register\/?[^/]*$/,
  /^\/forgot-password$/,
  /^\/reset-password$/,
  /^\/lesson\/[^/]+$/, // Leçons publiques simples
  /^\/lesson\/.*$/, // Leçons publiques complexes (virtual-keyboard, exercises, etc.)
  /^\/category\/[^/]+$/, // Catégories publiques
  /^\/services(\/.*)?$/, // Toutes les pages de services
  /^\/payment-success$/, // Page de confirmation paiement
  // ... ajoute ici tout ce que tu veux explicitement en public
];
export default defineNuxtRouteMiddleware(async (to, from) => {
  // 1️⃣ Check PUBLIC before ANYTHING ELSE
  if (
    publicPaths.includes(to.path) ||
    publicPatterns.some((pattern) => {
      const isMatch = pattern.test(to.path);
      if (isMatch) {
        console.log("✔ PUBLIC ROUTE MATCHED:", to.path, pattern.toString());
      }
      return isMatch;
    })
  ) {
    return;
  }

  // ... ici seulement tu continues le reste du middleware (session, rôles...)
  const authStore = useAuthStore();
  if (!authStore.isRestored) {
    const ok = await authStore.restoreAuth();
    if (!ok) {
      return navigateTo("/login");
    }
  }
  if (!authStore.isLoggedIn) {
    return navigateTo("/login");
  }
  // 4) Récupération des rôles pour vérifier accès par préfixes
  const userRoles = authStore.profile.roles || [];

  // – Les admins passent partout
  if (userRoles.includes("admin")) {
    return;
  }

  // – Définition des routes protégées par préfixe et des rôles autorisés
  const roleBasedRoutes = {
    "/instructor": ["instructor"],
    "/blogger": ["blogger"],
    "/user": ["user"],
    "/student": ["student"],
    "/admin": ["admin"],
  };

  // – Si la route commence par un préfixe protégé et que le rôle ne correspond pas
  for (const [prefix, roles] of Object.entries(roleBasedRoutes)) {
    if (
      to.fullPath.startsWith(prefix) &&
      !roles.some((r) => userRoles.includes(r))
    ) {
      return navigateTo("/forbidden");
    }
  }

  // 5) Si l’utilisateur est connecté mais n’a AUCUN rôle, on renvoie vers la page 403
  if (!userRoles.length) {
    return navigateTo("/403");
  }

  // 6) Sinon, on laisse la navigation se poursuivre
});
